/**
 * @generated SignedSource<<68f1f2e85c8633f08fac2b1267010529>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLeadingImagesContent$data = {
  readonly images: ReadonlyArray<{
    readonly isSlideshow: boolean | null;
    readonly size1020x680: {
      readonly url: string | null;
    } | null;
    readonly size1200x800: {
      readonly url: string | null;
    } | null;
    readonly size768x768: {
      readonly url: string | null;
    } | null;
    readonly title: string | null;
    readonly url: string;
  } | null> | null;
  readonly " $fragmentType": "articleLeadingImagesContent";
};
export type articleLeadingImagesContent$key = {
  readonly " $data"?: articleLeadingImagesContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeadingImagesContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLeadingImagesContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        {
          "alias": "size1200x800",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "1200x800"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"1200x800\"})"
        },
        {
          "alias": "size1020x680",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "1020x680"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"1020x680\"})"
        },
        {
          "alias": "size768x768",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "768x768"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "style(filter:{\"style\":\"768x768\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "0d73a50b6e4ca9765d510da1de3c7739";

export default node;
